import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AccountDropdown.css';

const AccountDropdown = ({ title, items, isOpen, onToggle, onLogout, onSelect, mobileHref, variant }) => {
  const navigate = useNavigate();

  const handlePrimaryAction = () => {
    if (mobileHref && window.matchMedia('(max-width: 900px)').matches) {
      onToggle(null);
      navigate(mobileHref);
      return;
    }

    onToggle(isOpen ? null : title);
  };

  return (
    <div
      className={[
        'account-dropdown',
        mobileHref ? 'account-dropdown--mobile-direct' : '',
        variant ? `account-dropdown--${variant}` : '',
      ].filter(Boolean).join(' ')}
      onMouseEnter={() => {
        if (!window.matchMedia('(max-width: 900px)').matches) onToggle(title);
      }}
      onMouseLeave={() => {
        if (!window.matchMedia('(max-width: 900px)').matches) onToggle(null);
      }}
    >
      <button type="button" className="account-dropdown-link" onClick={handlePrimaryAction}>
        {title}
      </button>
      {isOpen && (
        <div className="account-dropdown-menu">
          {items.map((item, index) => (
            item.action ? (
              <button
                type="button"
                key={index}
                onClick={() => {
                  if (item.action === 'logout') onLogout?.();
                  else onSelect?.(item);
                  onToggle(null);
                }}
                className="account-dropdown-item"
                aria-current={item.current ? 'true' : undefined}
              >
                {item.label}
              </button>
            ) : (
              <a
                key={index}
                href={item.link}
                className="account-dropdown-item"
              >
                {item.label}
              </a>
            )
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
